var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("header", { staticClass: "section-safety" }, [
      _c("div", { staticClass: "row row-safety-hero" }, [
        _c("div", { staticClass: "col-12 text-center" }, [
          _c("div", { staticClass: "hero-title -white" }, [
            _vm._v(_vm._s(_vm.$t("message.safety.title")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "hero-sub-title -white" }, [
            _vm._v(_vm._s(_vm.$t("message.safety.subtitle")))
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "section-padding section-solution" }, [
      _c("h2", { staticClass: "text-center" }, [
        _vm._v(_vm._s(_vm.$t("message.safety.benefits_title")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4 col-sm-4 text-center" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("message.safety.benefits_title01")))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text-left" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm.$t("message.safety.benefits_detail01")) +
                    "\n              "
                ),
                _c("ul", { staticClass: "list-unstyled" }, [
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.safety.insurance_cleaning")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.safety.insurance_ironing")))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4 col-sm-4 text-center" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("message.safety.benefits_title02")))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text-left" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm.$t("message.safety.benefits_detail02")) +
                    "\n            "
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4 col-sm-4 text-center" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("message.safety.benefits_title03")))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text-left" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm.$t("message.safety.benefits_detail03")) +
                    "\n            "
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-image" }, [
      _c("img", { attrs: { src: "/static/img/safety01.jpg", alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-image" }, [
      _c("img", { attrs: { src: "/static/img/safety02.jpg", alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-image" }, [
      _c("img", { attrs: { src: "/static/img/safety03.jpg", alt: "" } })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e3f40c5", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e3f40c5","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/Safety.vue
// module id = 1533
// module chunks = 0